<template>
  <SimpleDataTable
    :title="'Alacaklı Cari Listesi'"
    :description="''"
    :dataList="top10CurrentPayeeList"
    :dataHeaders="top10CurrentPayeeListHeaders"
    :loading="top10CurrentPayeeListLoading"
    :pagination-status="true"
    :pagination-length="maxPage"
    @page-change="handlePageChange"
  >
  </SimpleDataTable>
</template>

<script>
import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import { mapActions, mapState } from "vuex";
import { numberConverter } from "../../../../helpers";

export default {
  name: "Top10AlacakliCariListesi",
  components: {
    SimpleDataTable,
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null,
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null,
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  mounted() {
    this._fetchPayeeCurrentList();
  },
  data() {
    return {
      maxPage: null,
      currentPage: 1,
      top10CurrentPayeeList: [],
      top10CurrentPayeeListHeaders: [],
      top10CurrentPayeeListLoading: false,
    };
  },
  methods: {
    ...mapActions("dashboard", ["fetchPayeeCurrentList"]),
    numberConverter,
    async handlePageChange(newPage) {
      this.currentPage = newPage;
      await this._fetchPayeeCurrentList();
    },
    _fetchPayeeCurrentList() {
      this.fetchPayeeCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          pageSize: 10,
          ...(!(
            this.dashboardFilterCurrentCodeProp === "" ||
            this.dashboardFilterCurrentCodeProp == null
          ) && { currentCode: this.dashboardFilterCurrentCodeProp }),
          ...(!(
            this.dashboardFilterSalesPersonCodeProp === "" ||
            this.dashboardFilterSalesPersonCodeProp == null
          ) && { salesPersonCode: this.dashboardFilterSalesPersonCodeProp }),
          ...(!(
            this.dashboardFilterReportDbNameProp === "" ||
            this.dashboardFilterReportDbNameProp == null
          ) && { reportDbName: this.dashboardFilterReportDbNameProp }),
        },
        body: {},
      }).then((result) => {
        if (result && result.data.success) {
          this.top10CurrentPayeeListHeaders = [
            {
              key: "currentCode",
              label: "Cari Kodu",
              sortable: false,
              class: "align-middle",
            },
            {
              key: "currentName",
              label: "Cari Adı",
              sortable: false,
              class: "align-middle",
            },
            {
              class: "text-center align-middle",
              key: "balance",
              label: "Bakiye",
              sortable: false,
            },
            {
              class: "text-center align-middle",
              key: "currencyBalance",
              label: "Dövizli Bakiye",
              sortable: false,
            },
          ];
          this.top10CurrentPayeeList = result.data.data;
          this.maxPage = result.data.totalPages;
          this.top10CurrentPayeeList.map(
            (item) => (item.balance = numberConverter(item.balance))
          );
          this.top10CurrentPayeeList.map(
            (item) =>
              (item.currencyBalance = numberConverter(item.currencyBalance))
          );
        }
      });
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchPayeeCurrentList();
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchPayeeCurrentList();
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchPayeeCurrentList();
    },
  },
};
</script>

<style scoped></style>
